(() => {
  if (window.__ocDesktopFilterCollapseV3) return;
  window.__ocDesktopFilterCollapseV3 = true;

  const desktopMq = window.matchMedia('(min-width: 750px)');

  const setCollapsed = (collapsed, moveFocus = true) => {
    if (!desktopMq.matches) collapsed = false;

    document.body.classList.toggle('oc-desktop-filters-collapsed', collapsed);

    document.querySelectorAll('[data-oc-filter-collapse]').forEach((button) => {
      button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });

    if (!moveFocus) return;

    requestAnimationFrame(() => {
      if (collapsed) {
        document.querySelector('[data-oc-filter-restore]')?.focus({ preventScroll: true });
      } else {
        const collapseButton = document.querySelector('[data-oc-filter-collapse]');
        if (collapseButton) collapseButton.focus({ preventScroll: true });
        if (typeof window.OCAlignDesktopFacetPanel === 'function') {
          window.OCAlignDesktopFacetPanel();
        }
      }
    });
  };

  document.addEventListener('click', (event) => {
    const collapse = event.target.closest?.('[data-oc-filter-collapse]');
    if (collapse && desktopMq.matches) {
      event.preventDefault();
      setCollapsed(true);
      return;
    }

    const restore = event.target.closest?.('[data-oc-filter-restore]');
    if (restore && desktopMq.matches) {
      event.preventDefault();
      setCollapsed(false);
    }
  });

  desktopMq.addEventListener?.('change', () => {
    if (!desktopMq.matches) setCollapsed(false, false);
  });
})();